<template>
  <div v-if='block != null'>
      <h1 class="pageHeader">
        <span class="pageHeader__title">Block <span id="blockHeightCap">#{{ block.height }}</span></span>
      </h1>

      <div class="row">
        <div class="col-xl-5 mb-5">
          <table class="table" id="blockSummary">
            <tbody>
              <tr class="table__header">
                <th class="table__title table__title--low" colspan="2">Summary</th>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Number of Transactions </td>
                <td class="table__cell txt-white"> {{ block.tx.length }} </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Total Output </td>
                <td class="table__cell txt-white"> {{ getter_total_out | formatPlc }} </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Transaction Fees </td>
                <td class="table__cell txt-white"> {{ getter_total_fees | formatPlc }} </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Time Ago </td>
                <td class="table__cell txt-white">
                  <timeago :since="block.time * 1000"
                           :auto-update="60"
                           class="timeago"></timeago>
                </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Date and Time </td>
                <td class="table__cell txt-white"> {{ block.time | setDateAndTime }} </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Blocks Ago </td>
                <td class="table__cell txt-white"> {{ block.confirmations - 1 }} </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Size </td>
                <td class="table__cell txt-white"> {{ block.size }} B </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Difficulty </td>
                <td class="table__cell txt-white"> {{ block.difficulty.toExponential(5) }} </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Bits </td>
                <td class="table__cell txt-white"> {{ block.bits }} </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Version </td>
                <td class="table__cell txt-white"> {{ block.version }} </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Nonce </td>
                <td class="table__cell txt-white"> {{ block.nonce }} </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-xl-7 mb-5">
          <table class="table table--awd" id="blockHashes">
            <tbody>
              <tr class="table__header">
                <th class="table__title table__title--low">Hashes</th>
                <th class="hidden-xs-down"></th>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Hash </td>
                <td class="table__cell txt-white">
                  <router-link :to="{ path: '/block/' + block.hash }"
                               class="link">
                    {{ block.hash }}
                  </router-link>
                </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Previous Block </td>
                <td class="table__cell txt-white">
                  <router-link :to="{ path: '/block/' + block.previousblockhash }"
                               class="link">
                    {{ block.previousblockhash }}
                  </router-link>
                </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Next Block </td>
                <td class="table__cell txt-white">
                  <router-link :to="{ path: '/block/' + block.nextblockhash }"
                               class="link">
                    {{ block.nextblockhash }}
                  </router-link>
                </td>
              </tr>
              <tr class="table__row">
                <td class="table__cell txt-gray"> Merkle Root </td>
                <td class="table__cell txt-white"> {{ block.merkleroot }} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div id="blockVisual">
        <h3 class="table__header table__header--transactions table__title--capitalize">
          <img class="icon" src="../assets/img/check-box.png" alt="check-box">Transactions
        </h3>
        <div v-for='tx in block.tx'
             :key='tx.txid'
             class='txdiv'>
          <table class='table table--awd'>
            <tbody>
              <tr class="table__header">
                <td class='table__title table__title--lowercase hidden-xs-down' colspan='3'>
                  <router-link :to="{ path: '/tx/' + tx.txid }"
                               class="link link--gray">
                    {{ tx.txid }}
                  </router-link>
                  <span class="table__txRight"></span>
                </td>
              </tr>

              <tr class="table__header">
                <td class='table__title table__title--lowercase hidden-sm-up'>
                  <router-link :to="{ path: '/tx/' + tx.txid }"
                               class="link link--gray">
                    {{ tx.txid }}
                  </router-link>
                  <span class="table__txRight"></span>
                </td>
              </tr>

              <tr class="table__row table__row--trasparent">
                <td class='table__cell table__cell--input txt-white'>
                  <template v-if="tx.inputs.length == 0 || tx.inputs[0].length == 0">
                    Coinbase (newly generated coins)
                  </template>
                  <template v-else>
                    <template v-for="input in tx.inputs">
                      <router-link v-if="input != moneybox"
                                   :key='input'
                                   :to="{ path: '/address/' + input }"
                                   class="link"> {{ input }} <br/> </router-link>
                    </template>
                  </template>
                </td>
                <v-iarrow :tx="tx"></v-iarrow>
                <td class='table__cell table__cell--output txt-white'>
                  <template v-for="(output, index) in tx.outputs">
                    <template v-if="output.address != moneybox || tx.type && tx.type == 'coinbase'">
                      <div :key="index + 'link'" >
                      <router-link v-if="output.address != moneybox"
                                   :to="{ path: '/address/' + output.address }"
                                   class="link">
                        {{ output.address }}
                      </router-link>
                      <router-link v-else-if="tx.type && tx.type == 'coinbase'"
                                   :to="{ path: '/address/' + output.address }"
                                   class="link"> PLC Minting Depot </router-link>
                      <span>
                        <span class="table__txRight table__txRight--sm-left txt-white">
                          <template v-if="index == 0 && tx.type == 'minting'">
                            {{ output.value - tx.additional.minting.minted | formatPlc }}
                          </template>
                          <template v-else>
                            {{ output.value | formatPlc }}
                          </template>
                        </span>
                      </span>
                      <br/>
                    </div>
                    </template>
                  </template>
                  <template v-if="tx.type == 'minting'">
                    Minted Coins
                    <span>
                      <span class="table__txRight table__txRight--sm-left txt-white">
                        {{ tx.additional.minting.minted | formatPlc }}
                      </span>
                    </span>
                    <br/>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </div>
</template>

<script>
import ApiService from '../service/ApiService'

export default {
  name: 'Block',

  data: () => ({
    getter_total_out: 0,
    getter_total_fees: 0,
    getter_block_date: '',
    block: null,
    moneybox: ''
  }),

  watch: {
    '$route': 'fetchBlock'
  },

  created () {
    this.fetchBlock()
  },

  errorCaptured (err, vm, info) {
    console.log(err)
  },

  methods: {
    async fetchBlock () {
      try {
        const info = await ApiService.getInfo()
        if (!info) {
          throw Error('Failed to load information')
        }
        this.moneybox = info.moneybox

        const response = await ApiService.searchById(this.$route.params.id)
        if (!response) {
          this.$router.push({ path: '/not-found' })
          return
        }
        this.block = response.result
        this.setTotalFeesAndOut()
      } catch (error) {
        let obj = {
          title: 'Oops!',
          message: 'Internal error. Please let us know.',
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.opensimplert(obj)
      }
    },

    setTotalFeesAndOut () {
      this.getter_total_out = 0
      this.block.tx.forEach(tx => {
        this.getter_total_fees += tx.inputs.length !== 0 ? tx.inputsValue - tx.outputsValue : 0
        this.getter_total_out += tx.outputsValue
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Block.vue